import React, { useState, useEffect, useCallback, useRef } from 'react';
import styles from './styles/ScenarioComments.module.css';


const CommentForm = ({ 
    onSubmit, 
    initialValue = '', 
    isEditMode = false, 
    onCancel = null 
}) => {

    const [message, setMessage] = useState(initialValue);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message.trim()) return;

        setIsSubmitting(true);
        try {
            await onSubmit(message);
            if (!isEditMode) setMessage(''); 
        } catch (error) {
            console.error("Error submitting comment:", error);
            alert("Failed to submit comment.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.commentForm}>
            <textarea
                className={styles.textarea}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Write a comment..."
                disabled={isSubmitting}
                rows={3}
            />
            <div className={styles.formActions}>
                <button 
                    type="submit" 
                    disabled={isSubmitting || !message.trim()}
                    className={styles.submitButton}
                >
                    {isSubmitting ? 'Submitting...' : (isEditMode ? 'Save Changes' : 'Post Comment')}
                </button>
                
                {isEditMode && onCancel && (
                    <button 
                        type="button" 
                        onClick={onCancel} 
                        disabled={isSubmitting} 
                        className={styles.cancelButton}
                    >
                        Cancel
                    </button>
                )}
            </div>
        </form>
    );
};

export default CommentForm
